import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CONFIG, IMAGES } from "../../lib/config";

const chapters = [
  {
    n: "01",
    title: "Un collectif, pas un promoteur",
    body: "AKTRA n'organise pas des soirées, on construit des moments. Chaque événement est pensé comme une expérience qui te happe dès la première seconde.",
  },
  {
    n: "02",
    title: "Fondé par C_Dr — alias Daryl",
    body: "Derrière AKTRA, il y a Daryl (C_Dr) : une vision claire, une obsession du détail et l'envie de faire vivre à sa ville des nuits dont on parle encore des semaines après.",
  },
  {
    n: "03",
    title: "Éclipse — la fin d'été",
    body: "Pour clôturer l'été, AKTRA frappe fort : le premier DJ set de Nokuji, des artistes surprises, et une énergie pensée pour ne jamais retomber.",
  },
];

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="manifeste"
      ref={ref}
      data-testid="manifesto-section"
      className="relative border-t border-white/10 bg-[#09090b] py-24 lg:py-40"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 px-5 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="mb-6 font-mono-x text-xs uppercase tracking-[0.3em] text-[#FF0000]"
          >
            [ Le manifeste ]
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-white lg:text-7xl"
          >
            Qui est<br />
            <span className="text-[#FF0000]">AKTRA</span>&nbsp;?
          </motion.h2>

          <div className="relative mt-10 aspect-[3/4] overflow-hidden">
            <motion.img
              style={{ y: imgY, scale: 1.2 }}
              src={IMAGES.crowd}
              alt="Foule AKTRA"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#09090b] via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 font-mono-x text-[10px] uppercase tracking-[0.25em] text-white/70">
              AKTRA — {CONFIG.location}
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center gap-px lg:col-span-6 lg:col-start-7">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group border-t border-white/10 py-8 last:border-b"
            >
              <div className="flex items-start gap-6">
                <span className="font-mono-x text-sm text-[#FF0000]">{c.n}</span>
                <div>
                  <h3 className="font-display text-2xl uppercase tracking-tight text-white transition-colors duration-300 group-hover:text-[#FF0000] lg:text-3xl">
                    {c.title}
                  </h3>
                  <p className="mt-3 max-w-lg text-base leading-relaxed text-zinc-400">
                    {c.body}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
